<!--Header for Print-->
<div class="print-header">
  <div class="print-header--logo">
    <img src="../../assets/brand/meteofocus-logo-350.png" alt="wm-logo" />
  </div>
  <!--TODO: kann gelöscht werden wenn entschieden woe Text stehen soll (unten/oben)-->
  <!--<div class="print-header&#45;&#45;text">
    <p class="print-header-address">Wettermanufaktur GmbH <br> Bessemerstr.16 <br> 12103 Berlin</p>
    <p class="print-header-web-address">www.wettermanufaktur.de <br> info@wettermanufaktur.de</p>
  </div>-->
</div>

@if (!auth.isAppWebView()) {
  <mat-toolbar class="toolbar">
    @if (isHandset$ | async) {
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
    }
    @if (drawer && drawer.mode === 'side') {
      <img
        class="logo"
        alt="Logo"
        src="assets/brand/meteofocus-logo-350.png"
        height="48" />
    }
    <!--<pre> </pre><img src="assets/icons/Preview.png" alt="preview" height="32">-->
    <span class="navbar-spacer"></span>
    @let userNameValue = userName();
    @let userAliasValue = userAlias();
    <ul>
      <li>
        <button
          mat-icon-button
          (click)="toggleTheme()"
          aria-label="Theme umschalten">
          <mat-icon>{{ isDarkMode() ? 'light_mode' : 'dark_mode' }}</mat-icon>
        </button>
      </li>
      <li>
        <button mat-button [matMenuTriggerFor]="menuTranslate">
          <img
            class="u-responsive-img"
            src="assets/images/flags/{{ language() }}.png"
            [alt]="'HOME.LANGUAGE' | translate" />
        </button>
      </li>
      <li>
        @let userIconValue = userIcon();
        @if ((isHandset$ | async) === false) {
          <button type="button" mat-button [matMenuTriggerFor]="menuUser">
            <fa-icon
              class="menu-icon"
              [icon]="['far', userIconValue]"></fa-icon>
            @if (userNameValue) {
              <span class="user-name">
                {{ userNameValue }}
                @if (userAliasValue) {
                  <span>
                    [{{ 'HOME.HEADER.AS' | translate }} {{ userAliasValue }}]
                  </span>
                }
              </span>
            }
            <fa-icon
              class="menu-icon"
              [icon]="['far', 'chevron-down']"></fa-icon>
          </button>
        } @else {
          <button
            style="margin-bottom: 5px"
            mat-icon-button
            [matMenuTriggerFor]="menuUser">
            <fa-icon
              class="menu-icon"
              [icon]="['far', userIconValue]"></fa-icon>
          </button>
        }
      </li>
    </ul>
    <!-- Menu language -->
    <mat-menu #menuTranslate="matMenu">
      <button mat-menu-item (click)="changeLanguage('de'); translate.use('de')">
        <img
          src="assets/images/flags/de.png"
          [alt]="'HOME.GERMAN' | translate" />&nbsp;
        <span>{{ 'HOME.GERMAN' | translate }}</span>
      </button>
      <button mat-menu-item (click)="changeLanguage('nl'); translate.use('nl')">
        <img
          src="assets/images/flags/nl.png"
          [alt]="'HOME.DUTCH' | translate" />&nbsp;
        <span>{{ 'HOME.DUTCH' | translate }}</span>
      </button>
      <button mat-menu-item (click)="changeLanguage('us'); translate.use('us')">
        <img
          src="assets/images/flags/us.png"
          [alt]="'HOME.ENGLISH' | translate" />&nbsp;
        <span>{{ 'HOME.ENGLISH' | translate }}</span>
      </button>
      <button mat-menu-item (click)="changeLanguage('fr'); translate.use('fr')">
        <img
          src="assets/images/flags/fr.png"
          [alt]="'HOME.FRENCH' | translate" />&nbsp;
        <span>{{ 'HOME.FRENCH' | translate }}</span>
      </button>
      <button mat-menu-item (click)="changeLanguage('es'); translate.use('es')">
        <img
          src="assets/images/flags/es.png"
          [alt]="'HOME.SPANISH' | translate" />&nbsp;
        <span>{{ 'HOME.SPANISH' | translate }}</span>
      </button>
      <button
        mat-menu-item
        (click)="changeLanguage('es-ct'); translate.use('es-ct')">
        <img
          src="assets/images/flags/es-ct.png"
          [alt]="'HOME.CATALAN' | translate" />&nbsp;
        <span>{{ 'HOME.CATALAN' | translate }}</span>
      </button>
      <button
        mat-menu-item
        (click)="changeLanguage('ch-de'); translate.use('ch-de')">
        <img
          src="assets/images/flags/ch-de.png"
          [alt]="'HOME.SWISSGERMAN' | translate" />&nbsp;
        <span>{{ 'HOME.SWISSGERMAN' | translate }}</span>
      </button>
    </mat-menu>
    <!-- Menu user -->
    <mat-menu #menuUser="matMenu">
      @if (isHandset$ | async) {
        <button mat-menu-item disabled>
          @if (userNameValue) {
            <span>{{ userNameValue }}</span>
          }
        </button>
        <button mat-menu-item disabled>
          @if (userAliasValue) {
            <span
              >[{{ 'HOME.HEADER.AS' | translate }} {{ userAliasValue }}]</span
            >
          }
        </button>
      }

      @if (isMaster()) {
        <button mat-menu-item (click)="showCustomerList.set(true)">
          <fa-icon class="menu-icon" [icon]="['far', 'user-secret']"></fa-icon>
          {{ 'HOME.HEADER.BE_SOMEONE_ELSE' | translate }}
        </button>
      }
      @if (userAliasValue) {
        <button mat-menu-item (click)="onCustomerUnselect()">
          <fa-icon class="menu-icon" [icon]="['far', 'smile']"></fa-icon>
          <span>{{ 'HOME.HEADER.BE_YOU_AGAIN' | translate }}</span>
        </button>
      }
      <button mat-menu-item routerLink="/logout">
        <fa-icon class="menu-icon" [icon]="['far', 'sign-out']"></fa-icon>
        {{ 'HOME.LOGOUT' | translate }}
      </button>
    </mat-menu>
    <!-- customer list -->
    @if (showCustomerList()) {
      <mat-card appearance="outlined" class="be-customer-card">
        <button
          mat-icon-button
          style="position: absolute; right: 10px; top: 10px; z-index: 99"
          (click)="showCustomerList.set(false)">
          <i class="far fa-times fa-lg"></i>
        </button>
        <form class="be-customer-form">
          <mat-form-field class="be-customer-full-width">
            <input
              matInput
              placeholder="{{ 'HOME.HEADER.ENTER_CUSTOMER_NAME' | translate }}"
              aria-label="Kunde"
              [matAutocomplete]="auto"
              [formControl]="customerCtrl"
              type="search"
              autocomplete="off" />
            <mat-autocomplete #auto="matAutocomplete">
              @for (customer of filteredCustomers | async; track $index) {
                <mat-option
                  [value]="customer.customerName"
                  (onSelectionChange)="onCustomerSelect(customer)">
                  <span>{{ customer.customerName }}</span>
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </form>
      </mat-card>
    }
  </mat-toolbar>
}
<mat-sidenav-container class="sidenav-container">
  <div class="glass-background-blobs">
    <div class="blob blob-1"></div>
    <div class="blob blob-2"></div>
    <div class="blob blob-3"></div>
  </div>

  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [disableClose]="true"
    [opened]="(isHandset$ | async) === false">
    <mat-toolbar>Menu</mat-toolbar>
    <mat-nav-list>
      @let isMasterValue = auth.isMaster();
      @let customerAliasValue = auth.getCustomerAlias();
      @let customerDocumentValue = auth.getCustomerDocument();
      @let hasUserWebAccessValue = auth.hasUserWebAccess();
      @let userMetadataValue = auth.getUserProfile()?.['metadata'];
      @let hasUserAdminPermissionsValue = auth.hasUserAdminPermissions();
      <!--Dashboard-->
      <a
        mat-list-item
        routerLinkActive
        #routerLinkActiveInstanceDashboard="routerLinkActive"
        [attr.tabindex]="routerLinkActiveInstanceDashboard.isActive ? 0 : -1"
        class="nav-item-dashboard"
        [class.list-item-active]="routerLinkActiveInstanceDashboard.isActive"
        [routerLink]="['/dashboard']"
        (click)="onMenuSelected(drawer)">
        <fa-icon
          matListItemIcon
          [icon]="[
            routerLinkActiveInstanceDashboard.isActive ? 'fas' : 'far',
            'home',
          ]"></fa-icon>
        <div matListItemTitle>
          <span>{{ 'HOME.DASHBOARD.TITLE' | translate }}</span>
        </div>
      </a>
      <!-- Pigeons -->
      @let arePigeonProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'pigeonProducts';
      @if (arePigeonProductsActive) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstancePigeons="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstancePigeons.isActive ? 0 : -1"
          [class.list-item-active]="routerLinkActiveInstancePigeons.isActive"
          class="nav-item-pigeons"
          [routerLink]="['/pigeons']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstancePigeons.isActive ? 'fas' : 'far',
              'dove',
            ]"></fa-icon>
          <div matListItemTitle>
            {{ 'PRODUCT.PIGEONS.TITLE' | translate }}
          </div>
        </a>
      }
      <!--ERP-->
      @let hasErpPermission =
        isMasterValue
          | erpPermission
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue;
      @if (hasErpPermission) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceErp="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceErp.isActive ? 0 : -1"
          class="nav-item-erp"
          [class.list-item-active]="routerLinkActiveInstanceErp.isActive"
          [routerLink]="['/erp']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceErp.isActive ? 'fas' : 'far',
              'sigma',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.ERP.TITLE' | translate }} </span>
          </div>
        </a>
      }
      <!--EPP-->
      @let areEppProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'eppProducts';
      @if (areEppProductsActive) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceEpp="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceEpp.isActive ? 0 : -1"
          class="nav-item-epp"
          [class.list-item-active]="routerLinkActiveInstanceEpp.isActive"
          [routerLink]="['/epp']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceEpp.isActive ? 'fas' : 'far',
              'clouds-sun',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.EPP.TITLE' | translate }}</span>
          </div>
        </a>
      }
      <!--EPS-->
      @let areEnsembleProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'ensembleProducts';
      @if (areEnsembleProductsActive) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceEps="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceEps.isActive ? 0 : -1"
          class="nav-item-eps"
          [class.list-item-active]="routerLinkActiveInstanceEps.isActive"
          [routerLink]="['/eps']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceEps.isActive ? 'fas' : 'far',
              'chart-line',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.EPS.TITLE' | translate }}</span>
          </div>
        </a>
      }
      <!--EGP-->
      @let areEgpProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'egpProducts';
      @let areEgpSummerProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'egpSummerProducts';
      @if (areEgpProductsActive || areEgpSummerProductsActive) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceEgp="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceEgp.isActive ? 0 : -1"
          class="nav-item-egp"
          [class.list-item-active]="routerLinkActiveInstanceEgp.isActive"
          [routerLink]="['/egp']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceEgp.isActive ? 'fas' : 'far',
              'border-all',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.EGP.TITLE' | translate }}</span>
          </div>
        </a>
      }
      <!--EGW-->
      @let areEgwProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'egwProducts';
      @let areEgwSummerProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'egwSummerProducts';
      @if (areEgwProductsActive || areEgwSummerProductsActive) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceEgw="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceEgw.isActive ? 0 : -1"
          class="nav-item-egw"
          [class.list-item-active]="routerLinkActiveInstanceEgw.isActive"
          [routerLink]="['/warning']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceEgw.isActive ? 'fas' : 'far',
              'exclamation-triangle',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.WARNING.TITLE' | translate }}</span>
          </div>
        </a>
      }
      <!--SMW-->
      @let areSmwProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'smwProducts'
            : null
            : true;
      @if (areSmwProductsActive) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceSmw="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceSmw.isActive ? 0 : -1"
          class="nav-item-smw"
          [class.list-item-active]="routerLinkActiveInstanceSmw.isActive"
          [routerLink]="['/smw']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceSmw.isActive ? 'fas' : 'far',
              'thermometer-half',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.SMW.TITLE' | translate }}</span>
          </div>
        </a>
      }
      <!--RADAR-->
      @let areRadarProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'radarProducts'
            : null
            : true;
      @if (areRadarProductsActive) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceRadar="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceRadar.isActive ? 0 : -1"
          class="nav-item-radar"
          [class.list-item-active]="routerLinkActiveInstanceRadar.isActive"
          [routerLink]="['/radar']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceRadar.isActive ? 'fas' : 'far',
              'umbrella',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.RADAR.TITLE' | translate }}</span>
          </div>
        </a>
      }
      @let areSatelliteProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'satelliteProducts'
            : null
            : false;
      @if (areSatelliteProductsActive) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceSat="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceSat.isActive ? 0 : -1"
          class="nav-item-sat"
          [class.list-item-active]="routerLinkActiveInstanceSat.isActive"
          [routerLink]="['/sat']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceSat.isActive ? 'fas' : 'far',
              'satellite',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.SATELLITE.TITLE' | translate }}</span>
          </div>
        </a>
      }
      @let areModelProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'modelProducts'
            : null
            : false;
      @if (areModelProductsActive) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceModel="routerLinkActive"
          class="nav-item-model"
          [attr.tabindex]="routerLinkActiveInstanceModel.isActive ? 0 : -1"
          [class.list-item-active]="routerLinkActiveInstanceModel.isActive"
          [routerLink]="['/model']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceModel.isActive ? 'fas' : 'far',
              'globe',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.MODEL.TITLE' | translate }}</span>
          </div>
        </a>
      }
      <!-- TREND -->
      @let areTrendProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'trendProducts';
      @if (areTrendProductsActive) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceTrend="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceTrend.isActive ? 0 : -1"
          class="nav-item-trend"
          [class.list-item-active]="routerLinkActiveInstanceTrend.isActive"
          [routerLink]="['/trend']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceTrend.isActive ? 'fas' : 'far',
              'telescope',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.TREND.TITLE' | translate }}</span>
          </div>
        </a>
      }
      <!-- MARWIS -->
      @let areMarwisProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'marwisProducts'
            : null
            : true;
      @if (areMarwisProductsActive) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceMarwis="routerLinkActive"
          class="nav-item-marwis"
          [attr.tabindex]="routerLinkActiveInstanceMarwis.isActive ? 0 : -1"
          [class.list-item-active]="routerLinkActiveInstanceMarwis.isActive"
          [routerLink]="['/marwis']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceMarwis.isActive ? 'fas' : 'far',
              'car',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.MARWIS.TITLE' | translate }}</span>
          </div>
        </a>
      }
      <!--ROUTE-FCST-->
      @let areRouteProductsActive =
        isMasterValue
          | isProductActive
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : 'routeProducts';
      @if (areRouteProductsActive) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceRouteFcst="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceRouteFcst.isActive ? 0 : -1"
          class="nav-item-route-fcst"
          [class.list-item-active]="routerLinkActiveInstanceRouteFcst.isActive"
          [routerLink]="['/route-fcst']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceRouteFcst.isActive ? 'fas' : 'far',
              'road',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.ROUTEFCST.TITLE' | translate }}</span>
          </div>
        </a>
      }

      @if (auth.hasUserOperationReport()) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceOpReport="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceOpReport.isActive ? 0 : -1"
          class="nav-item-logbook"
          [class.list-item-active]="routerLinkActiveInstanceOpReport.isActive"
          [routerLink]="['/operation-report']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceOpReport.isActive ? 'fas' : 'far',
              'clipboard-list-check',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.OPERATIONALREPORT.TITLE' | translate }}</span>
          </div>
        </a>
      }

      @if (hasUserLogbook()) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceLogbook="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceLogbook.isActive ? 0 : -1"
          class="nav-item-logbook"
          [class.list-item-active]="routerLinkActiveInstanceLogbook.isActive"
          [routerLink]="['/logbook']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceLogbook.isActive ? 'fas' : 'far',
              'book',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.LOGBOOK.TITLE' | translate }}</span>
          </div>
        </a>
      }

      <!--ARCHIVE-->
      @if (
        (customerDocumentValue | showArchive) &&
        hasUserWebAccessValue &&
        hasUserArchive()
      ) {
        <a
          mat-list-item
          #routerLinkActiveInstanceArchive="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceArchive.isActive ? 0 : -1"
          class="nav-item-archive"
          [class.list-item-active]="routerLinkActiveInstanceArchive.isActive"
          [routerLink]="['/archive']"
          (click)="onMenuSelected(drawer)"
          routerLinkActive="active-list-item">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceArchive.isActive ? 'fas' : 'far',
              'archive',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.ARCHIVE.TITLE' | translate }}</span>
          </div>
        </a>
      }
      <!-- M6 -->
      <!--TODO: adapt authentication not only for master -->
      @if (hasUserM6Permission()) {
        <a
          mat-list-item
          #routerLinkActiveInstanceM6="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceM6.isActive ? 0 : -1"
          class="nav-item-m6"
          [class.list-item-active]="routerLinkActiveInstanceM6.isActive"
          [routerLink]="['/m6']"
          (click)="onMenuSelected(drawer)"
          routerLinkActive="active-list-item">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceM6.isActive ? 'fas' : 'far',
              'tv-retro',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.M6.TITLE' | translate }}</span>
          </div>
        </a>
      }

      <!-- Verification -->
      @let verificationPermissionActive =
        isMasterValue
          | verificationPermission
            : customerAliasValue
            : customerDocumentValue
            : hasUserWebAccessValue
            : userMetadataValue
            : hasUserAdminPermissionsValue;
      @if (verificationPermissionActive) {
        <a
          mat-list-item
          #routerLinkActiveInstanceVerification="routerLinkActive"
          [attr.tabindex]="
            routerLinkActiveInstanceVerification.isActive ? 0 : -1
          "
          class="nav-item-verification"
          [class.list-item-active]="
            routerLinkActiveInstanceVerification.isActive
          "
          routerLink="/verification"
          routerLinkActive="active-list-item"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceVerification.isActive ? 'fas' : 'far',
              'tasks',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'PRODUCT.VERIFICATION.TITLE' | translate }}</span>
          </div>
        </a>
      }

      <!--USERADMIN-->
      @if (hasUserAdminPermissionsValue) {
        <a
          mat-list-item
          routerLinkActive
          #routerLinkActiveInstanceUserAdmin="routerLinkActive"
          [attr.tabindex]="routerLinkActiveInstanceUserAdmin.isActive ? 0 : -1"
          class="nav-item-useradmin"
          [class.list-item-active]="routerLinkActiveInstanceUserAdmin.isActive"
          [routerLink]="['/customer-data']"
          (click)="onMenuSelected(drawer)">
          <fa-icon
            matListItemIcon
            [icon]="[
              routerLinkActiveInstanceUserAdmin.isActive ? 'fas' : 'far',
              'users',
            ]"></fa-icon>
          <div matListItemTitle>
            <span>{{ 'HOME.USERADMIN' | translate }}</span>
          </div>
        </a>
      }

      <mat-divider style="padding: 5px"></mat-divider>
      <!--LOGOUT-->
      <a
        mat-list-item
        routerLinkActive
        #routerLinkActiveInstanceLogout="routerLinkActive"
        [attr.tabindex]="routerLinkActiveInstanceLogout.isActive ? 0 : -1"
        class="nav-item-logout"
        [class.list-item-active]="routerLinkActiveInstanceLogout.isActive"
        [routerLink]="['/logout']"
        (click)="onMenuSelected(drawer)">
        <fa-icon
          matListItemIcon
          [icon]="[
            routerLinkActiveInstanceLogout.isActive ? 'fas' : 'far',
            'sign-out',
          ]"></fa-icon>
        <div matListItemTitle>
          <span>{{ 'HOME.LOGOUT' | translate }}</span>
        </div>
      </a>

      <span mat-list-item class="side-nav-spacer"></span>

      <footer mat-list-item class="menu-bottom">
        <div class="menu-bottom__links">
          <a
            class="menu-bottom__link"
            target="_blank"
            rel="noopener noreferrer"
            href="{{ 'HOME.LINK.IMPRINT' | translate }}"
            [attr.aria-label]="'HOME.IMPRINT' | translate">
            <fa-icon [icon]="['far', 'file-signature']"></fa-icon>
            <span>{{ 'HOME.IMPRINT' | translate }}</span>
          </a>

          <a
            class="menu-bottom__link"
            target="_blank"
            rel="noopener noreferrer"
            href="{{ 'HOME.LINK.CONDITIONS' | translate }}"
            [attr.aria-label]="'HOME.CONDITIONS' | translate">
            <fa-icon [icon]="['far', 'shield-check']"></fa-icon>
            <span>{{ 'HOME.CONDITIONS' | translate }}</span>
          </a>

          <a
            class="menu-bottom__link"
            target="_blank"
            rel="noopener noreferrer"
            href="{{ 'HOME.LINK.CONTACT' | translate }}"
            [attr.aria-label]="'HOME.CONTACT' | translate">
            <fa-icon [icon]="['far', 'envelope']"></fa-icon>
            <span>{{ 'HOME.CONTACT' | translate }}</span>
          </a>
        </div>

        <div class="menu-bottom__meta">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="{{ 'HOME.LINK.LANDINGPAGE' | translate }}">
            &copy; {{ copyrightYear() }} {{ 'HOME.WM' | translate }}
          </a>
          <span>v{{ appVersion }}</span>
        </div>
      </footer>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<!--Footer for Print-->
<div class="print-footer">
  <p class="print-header-address">
    Wettermanufaktur GmbH <br />
    Bessemerstr.16, 12103 Berlin
  </p>
  <p class="print-header-web-address">
    www.wettermanufaktur.de <br />
    info&#64;wettermanufaktur.de
  </p>
</div>
